import { Suspense } from 'react';
import PageWrapper from '../PageWrapper/PageWrapper';
import Page from '../Page/Page';
import ContentRoutes from './ContentRoutes';
import Logo from '../../components/Logo';
import ActionSpinner from '../../custom/components/ActionSpinner';

const LOADING = (
	<PageWrapper>
		<Page>
			<div className='w-100 vh-100 d-flex flex-column justify-content-center align-items-center'>
				<Logo height={300} width={300} />
				<h5 className='h5 mt-3'>Fast & Reliable</h5>
			</div>
		</Page>
	</PageWrapper>
);

const Content = () => {
	return (
		<main className='content'>
			<Suspense fallback={<ActionSpinner />}>
				<ContentRoutes />
			</Suspense>
		</main>
	);
};

export default Content;
